import { Injectable } from '@angular/core';
import { PageCommonList } from '../models/page.model';

@Injectable({ providedIn: 'root' })
export class PageListService {
  // ✅ Quick Service Grid (Home 4-zone — max 6)
  quickServiceList = [
    {
      route: 'option-register-renew',
      nameTH: 'สมัครรายเดือน',
      nameEN: 'Monthly Pass',
      image: '/icons/parking-home.png',
      alt: 'monthly-pass',
      disable: false,
      alert: 'serviceProviders',
      action: '',
    },
    {
      route: 'ev-charger',
      nameTH: 'สถานีชาร์จ EV',
      nameEN: 'EV Charger',
      image: '/icons/charge-green.png',
      alt: 'ev-charger',
      disable: false,
      alert: 'evCount',
      action: '',
    },
    {
      route: 'activate-member-card',
      nameTH: 'เปิดใช้บัตร/ส่วนลด',
      nameEN: 'Activate Ticket',
      image: '/icons/identification-documents-yellow-black.png',
      alt: 'activate-card',
      disable: false,
      alert: 'activateCard',
      action: '',
    },
    {
      route: 'vehicles-option',
      nameTH: 'รถของฉัน',
      nameEN: 'My Cars',
      image: '/icons/car-home.png',
      alt: 'my-cars',
      disable: false,
      alert: 'vehiclesOption',
      action: '',
    },
    {
      route: 'discount-request',
      nameTH: 'ส่วนลดพิเศษ',
      nameEN: 'Special Discounts',
      image: '/icons/discount-home.png',
      alt: 'special-discounts',
      disable: true,
      alert: 'discount-request',
      action: '',
    },
    {
      route: 'more',
      nameTH: 'เพิ่มเติม',
      nameEN: 'More',
      image: '/icons/expand_more_slate_dark.svg',
      alt: 'more',
      disable: false,
      alert: 'more',
      action: 'more',
    },
  ];

  // ✅ เมนูหลัก (แนะนำ) — legacy / หน้าอื่น
  recommendList = [
    {
      route: 'option-register-renew',
      nameTH: 'สมัครจอดรายเดือน',
      nameEN: 'Monthly membership',
      image: '/icons/parking-home.png',
      alt: 'service-providers',
      disable: false,
      alert: 'serviceProviders',
    },
    {
      route: 'vehicles-option',
      nameTH: 'รถของฉัน',
      nameEN: 'My vehicle',
      image: '/icons/car-home.png',
      alt: 'vehiclesOption',
      disable: false,
      alert: 'vehiclesOption',
    },
    {
      route: 'my-member-card',
      nameTH: 'บัตรจอดรถของฉัน',
      nameEN: 'My card',
      image: '/icons/identification-documents-home.png',
      alt: 'myMemberCard',
      disable: false,
      alert: 'myMemberCard',
    },
    // {
    //   route: 'activate-member-card',
    //   nameTH: 'เปิดใช้งานบัตร',
    //   nameEN: 'Active card',
    //   image: '/icons/identification-documents-yellow-black.png',
    //   alt: 'activateCard',
    //   disable: false,
    //   alert: 'activateCard',
    // },
    {
      route: 'check-amount-parking',
      nameTH: 'รถกำลังจอด',
      nameEN: 'Your parking',
      image: '/icons/count_parking-yellow.png',
      alt: 'vehicleCount',
      disable: false,
      alert: 'vehicleCount',
    },
  ];

  commonList: PageCommonList[] = [
    {
      categoryTH: 'หน้าแรก',
      categoryEN: 'Home',
      list: [
        {
          route: 'home', // ลิงค์ไป หน้า
          nameTH: 'หน้าหลัก', // ชื่อ TH
          nameEN: 'Home', // ชื่อ EN
          image: '/icons/home-home.png', // รูปภาพ
          imageSlide: '/icons/home-home.png', // รูปภาพใน Slide bar
          imageActive: '/icons/home-home-white.png', // รูปภาพเมื่อ Active Slide bar
          alt: 'home', // ชื่อรูปภาพ
          disable: false, // ปิดการใช้งาน
          disableTextTH: 'ปิดปรับปรุง', // ข้อความปิดการใช้งาน TH
          disableTextEN: 'Coming soon', // ข้อความปิดการใช้งาน EN
          alert: 'home', // แจ้งเตือน
        },
      ],
    },
    {
      categoryTH: 'บริการ',
      categoryEN: 'Service',
      list: [
        {
          route: 'option-register-renew',
          nameTH: 'สมัครรายเดือน',
          nameEN: 'Monthly membership',
          image: '/icons/parking-home.png',
          imageSlide: '/icons/parking-home-gray.png',
          imageActive: '/icons/parking-white.png',
          alt: 'serviceProviders',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'serviceProviders',
        },
        {
          route: 'invite',
          nameTH: 'แนะนำเพื่อน',
          nameEN: 'Invite',
          image: '/icons/team-home.png',
          imageSlide: '/icons/team-home-gray.png',
          imageActive: '/icons/team-home-white.png',
          alt: 'invite',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'invite',
        },
        {
          route: 'ev-charger',
          nameTH: 'สถานีชาร์จ EV',
          nameEN: 'EV Charger',
          image: '/icons/charge-green.png',
          imageSlide: '/icons/charge-home.png',
          imageActive: '/icons/charge-home-white.png',
          alt: 'charge',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'evCount',
        },
        {
          route: 'check-amount-parking',
          nameTH: 'รถกำลังจอด',
          nameEN: 'Your parking',
          image: '/icons/count_parking.png',
          imageSlide: '/icons/count_parking-gray.png',
          imageActive: '/icons/count_parking-white.png',
          alt: 'vehicleCount',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'vehicleCount',
        },
        {
          route: 'discount-request',
          nameTH: 'ขอส่วนลด',
          nameEN: 'Discount request',
          image: '/icons/discount-home.png',
          imageSlide: '/icons/discount-home-gray.png',
          imageActive: '/icons/discount-home-white-2.png',
          alt: 'discount-request',
          disable: true,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'discount-request',
        },
        {
          route: 'activate-member-card',
          nameTH: 'เปิดใช้งานบัตร',
          nameEN: 'Active card',
          image: '/icons/identification-documents-yellow-black.png',
          imageSlide: '/icons/identification-documents-yellow-gray.png',
          imageActive: '/icons/identification-documents-yellow-white.png',
          alt: 'active-member-card',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'activateCard',
        },
        {
          route: 'payment-services',
          nameTH: 'ชำระค่าบริการ',
          nameEN: 'Pay services',
          image: '/icons/payment-service.png',
          imageSlide: '/icons/identification-documents-yellow-gray.png',
          imageActive: '/icons/identification-documents-yellow-white.png',
          alt: 'payment-services',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'payment-services',
        },
      ],
    },
    {
      categoryTH: 'ข้อมูลสมาชิก',
      categoryEN: 'Member information',
      list: [
        {
          route: 'vehicles-option',
          nameTH: 'รถของฉัน',
          nameEN: 'My vehicle',
          image: '/icons/car-home.png',
          imageSlide: '/icons/car-home-gray.png',
          imageActive: '/icons/car-home-white.png',
          alt: 'vehiclesOption',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'vehiclesOption',
        },
        {
          route: 'my-member-card',
          nameTH: 'บัตรจอดรถของฉัน',
          nameEN: 'My card',
          image: '/icons/identification-documents-home.png',
          imageSlide: '/icons/identification-documents-gray.png',
          imageActive: '/icons/member.png',
          alt: 'myMemberCard',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'myMemberCard',
        },
        // {
        //   route: 'vehicle-share',
        //   nameTH: 'รถแชร์ร่วมกัน',
        //   nameEN: 'Vehicle share',
        //   image: '/icons/vehicle_share.png',
        //   imageSlide: '/icons/vehicle_share_gray.png',
        //   imageActive: '/icons/vehicle_share_white.png',
        //   alt: 'vehicleShare',
        //   disable: false,
        //   disableTextTH: 'ปิดปรับปรุง',
        //   disableTextEN: 'Coming soon',
        //   alert: 'vehicleShare',
        // },
        {
          route: 'vehicle-share-inbox',
          nameTH: 'คำเชิญแชร์รถ',
          nameEN: 'Share invites',
          image: '/icons/vehicle_share.png',
          imageSlide: '/icons/vehicle_share_gray.png',
          imageActive: '/icons/vehicle_share_white.png',
          alt: 'vehicleShareInbox',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'vehicleShareInbox',
        },
      ],
    },
    {
      categoryTH: 'ประวัติ',
      categoryEN: 'History',
      list: [
        {
          route: 'parking-history',
          nameTH: 'ประวัติการเข้าจอด',
          nameEN: 'Parking history',
          image: '/icons/time-home.png',
          imageSlide: '/icons/time-home.png',
          imageActive: '/icons/time-home-white.png',
          alt: 'Parking history',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'Parking history',
        },
        {
          route: 'payment-history',
          nameTH: 'ขอ ใบเสร็จ/บิล',
          nameEN: 'Payment history',
          image: '/icons/bill-home.png',
          imageSlide: '/icons/bill-home-gray.png',
          imageActive: '/icons/bill-home-white-2.png',
          alt: 'Payment history',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'Payment history',
        },
      ],
    },
    {
      categoryTH: 'ช่วยเหลือ',
      categoryEN: 'Support',
      list: [
        {
          route: 'request-menu',
          nameTH: 'แบบฟอร์มคำร้อง\n(สมาชิก)',
          nameEN: 'Request menu',
          image: '/icons/form-home.png',
          imageSlide: '/icons/form-home-gray.png',
          imageActive: '/icons/form-home-white-2.png',
          alt: 'Request menu',
          disable: true,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'Request menu',
        },
        {
          route: 'report-main',
          nameTH: 'แจ้งปัญหา',
          nameEN: 'Report problem',
          image: '/icons/error-home.png',
          imageSlide: '/icons/error-home-gray.png',
          imageActive: '/icons/error-home-white.png',
          alt: 'Report problem',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'Setting',
        },
        // {
        //   route: 'customer-service-case',
        //   nameTH: 'ติดตามปัญหา',
        //   nameEN: 'Track cases',
        //   image: '/icons/customer-service-case.png',
        //   imageSlide: '/icons/customer-service-case-gray.png',
        //   imageActive: '/icons/customer-service-case-white.png',
        //   alt: 'Track cases',
        //   disable: false,
        //   disableTextTH: 'ปิดปรับปรุง',
        //   disableTextEN: 'Coming soon',
        //   alert: 'customerServiceCase',
        // },
        {
          route: 'setting',
          nameTH: 'ตั้งค่า',
          nameEN: 'Setting',
          image: '/icons/setting-home.png',
          imageSlide: '/icons/setting-home.png',
          imageActive: '/icons/setting-home-white.png',
          alt: 'Setting',
          disable: false,
          disableTextTH: 'ปิดปรับปรุง',
          disableTextEN: 'Coming soon',
          alert: 'Setting',
        },
      ],
    },
  ];
}
